<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Default Mapping
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<div class="container">
  <div class="row">
    <div class="col-sm-6 col-md-4 col-lg-3 mt-2">
      <mat-form-field style="width: 200px">
        <mat-label>Default Values</mat-label>
        <select matNativeControl [(ngModel)]="defaultValue"> 
          <option>Select Default Value</option>
          <option *ngFor="let defaultDetail of arrInnerAssetColumns" [value]="defaultDetail.value">
            {{defaultDetail.value}} - {{defaultDetail.description}} </option>
        </select>
      </mat-form-field>
    </div>
  </div>
  <button class="btn btn-semi-round w-30 bgBlue alertbtn" (click)="onSave()" style="margin-left: 46rem;margin-top: 13rem">
      Save
    </button>
</div>